import { Route, Routes } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import PrivateRoute from "./PrivateRoute";
//@ts-ignore
import { DashboardOverviewRouterService } from "@careinfo/dashboard-overview";
//@ts-ignore
import {
  ConsignmentRouterService,
  TrashConsignmentRouterService,
  HoldOrderRouterService,
  //@ts-ignore
} from "@careinfo/consignment";
//@ts-ignore
import { WarehouseRouterService } from "@careinfo/warehouse";
//@ts-ignore
import { CustomerRouterService } from "@careinfo/customer";
//@ts-ignore
import { StaffRouterService } from "@careinfo/staff";
//@ts-ignore
import { MerchantRouterService } from "@careinfo/merchant";
//@ts-ignore
import { RiderDriverRouterService } from "@careinfo/rider-driver";
//@ts-ignore
import { DarazOrderRouterService } from "@careinfo/vehicle-manifest";
import {
  ShipviaRouterService,
  //@ts-ignore
} from "@careinfo/settings";
import {
  SettingsRouterService,
  ConfigurationRouterService,
  //@ts-ignore
} from "@careinfo/settings";
import {
  RunsheetRouterService,
  ReturnOrderRouterService,
  ReturnBranchRouterService,
  //@ts-ignore
} from "@careinfo/runsheet";

//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from "@careinfo/permission-required";

//@ts-ignore
import { LocationRouterService } from "@careinfo/location";
//@ts-ignore
import { VehicleManifestRouterService } from "@careinfo/vehicle-manifest";
//@ts-ignore
import { VehicleRouterService } from "@careinfo/vehicle";

//@ts-ignore
import { ProductTypeRouterService } from "@careinfo/product-type";

//@ts-ignore
import { BranchRouterService } from "@careinfo/branch";

//@ts-ignore
import { StatusRouterService } from "@careinfo/status";

//@ts-ignore
import { DeliveryChargeRouterService } from "@careinfo/delivery-charge";

//@ts-ignore
import { ReferenceTypeRouterService } from "@careinfo/reference-type";

//@ts-ignore
import { PaymentMethodRouterService } from "@careinfo/payment-method";
import {
  PickupRequestRouterService,
  CourierPickupRequestRouterService,
  //@ts-ignore
} from "@careinfo/pickup-request-service";
//@ts-ignore
import { ServiceTypeRouterService } from "@careinfo/service-type";
//@ts-ignore
import {
  OverviewInvoiceRouterService,
  BranchInvoiceRouterService,
  MerchantInvoiceRouterService,
  RiderInvoiceRouterRouterService,
  //@ts-ignore
} from "@careinfo/finance-overview";
import { getKey } from "../helpers/sessionKey";
//@ts-ignore
import { WelcomeRouterService } from "@careinfo/welcome-page-service";
//@ts-ignore
import { DailyNoteRouterService } from "@careinfo/accounting-router-frontend-service";

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path={"/"}
          element={
            <AccessControl
              children={
                shouldShowWelcome === "true" || shouldShowWelcome === null ? (
                  <WelcomeRouterService />
                ) : (
                  <DashboardOverviewRouterService />
                )
              }
              allowedPermissions={["can_view_merchant_overview"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/overview"}
          element={
            <AccessControl
              children={<DashboardOverviewRouterService />}
              allowedPermissions={["can_view_merchant_overview"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/warehouse"}
          element={
            <AccessControl
              children={<WarehouseRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/order"}
          element={
            <AccessControl
              children={<ConsignmentRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/daraz-order"}
          element={
            <AccessControl
              children={<DarazOrderRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/hold-orders"}
          element={
            <AccessControl
              children={<HoldOrderRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/trash-order"}
          element={
            <AccessControl
              children={<TrashConsignmentRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/daily-notes"}
          element={
            <AccessControl
              children={<DailyNoteRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/daily-notes/create"}
          element={
            <AccessControl
              children={<DailyNoteRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/daily-notes/edit/:id"}
          element={
            <AccessControl
              children={<DailyNoteRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/delivery-charge-template"}
          element={
            <AccessControl
              children={<DeliveryChargeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/settings"}
          element={
            <AccessControl
              children={<SettingsRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/configuration"}
          element={
            <AccessControl
              children={<ConfigurationRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/international-pickup-request"}
          element={
            <AccessControl
              children={<PickupRequestRouterService />}
              allowedPermissions={["can_view_pickup_request"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/courier-pickup-request"}
          element={
            <AccessControl
              children={<CourierPickupRequestRouterService />}
              allowedPermissions={["can_view_pickup_request"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/customer"}
          element={
            <AccessControl
              children={<CustomerRouterService />}
              allowedPermissions={["can_view_user"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />

        <Route
          path={"/merchant"}
          element={
            <AccessControl
              children={<MerchantRouterService />}
              allowedPermissions={["can_view_user"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/staff"}
          element={
            <AccessControl
              children={<StaffRouterService />}
              allowedPermissions={["can_view_user"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/rider"}
          element={
            <AccessControl
              children={<RiderDriverRouterService />}
              allowedPermissions={["can_view_user"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/runsheet"}
          element={
            <AccessControl
              children={<RunsheetRouterService />}
              allowedPermissions={["can_view_runsheet"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/return-branch"}
          element={
            <AccessControl
              children={<ReturnBranchRouterService />}
              allowedPermissions={["can_view_rtv_return"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/vehicle"}
          element={
            <AccessControl
              children={<VehicleRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/address"}
          element={
            <AccessControl
              children={<LocationRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/product-type"}
          element={
            <AccessControl
              children={<ProductTypeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />

        <Route
          path={"/branch"}
          element={
            <AccessControl
              children={<BranchRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />

        <Route
          path={"/status-settings"}
          element={
            <AccessControl
              children={<StatusRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />

        <Route
          path={"/reference-type"}
          element={
            <AccessControl
              children={<ReferenceTypeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/payment-method"}
          element={
            <AccessControl
              children={<PaymentMethodRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/service-type"}
          element={
            <AccessControl
              children={<ServiceTypeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/vehicle-manifest"}
          element={<VehicleManifestRouterService />}
        />
        <Route
          path={"/finance-rider-invoice"}
          element={
            <AccessControl
              children={<RiderInvoiceRouterRouterService />}
              allowedPermissions={["can_view_rider_invoice"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/finance-merchant-invoice"}
          element={
            <AccessControl
              children={<MerchantInvoiceRouterService />}
              allowedPermissions={["can_view_merchant_invoice"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/finance-overview-invoice"}
          element={
            <AccessControl
              children={<OverviewInvoiceRouterService />}
              allowedPermissions={["can_view_merchant_invoice"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/finance-branch-invoice"}
          element={
            <AccessControl
              children={<BranchInvoiceRouterService />}
              allowedPermissions={["can_view_branch_invoice"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/ship-via"}
          element={
            <AccessControl
              children={<ShipviaRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
